export type UserLike = { role?: string } | null | undefined;

export const canIDoThis = (user: UserLike, right: string): boolean => {
  if (user?.role === "hyperadmin") {
    return true;
  }
  if (right === "super" && user?.role === "superadmin") {
    return true;
  }
  return false;
};
